<template>
  <v-card
    :color="getColor($vuetify.theme.themes.light.secondarytext, 0.1)"
    flat
  >
    <v-card-subtitle class="secondarytext--text font-weight-bold">
      <v-icon color="primary" class="mr-2" v-if="icon">{{ icon }}</v-icon>
      {{ title }}
    </v-card-subtitle>
    <v-card-text class="subtitle-1">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "InfoCard",
  props: {
    title: { type: String },
    icon: { type: String }
  }
};
</script>
